export class AutomationSummery {
  automationName: string;
  triggerConnectorName: string;
  triggerConnectorLogo: string;
  triggerEvent: string;
  actionConnectorName: string;
  actionConnectorLogo: string;
  actionEvent: string;
}
